export const useDateUtils = () => {
  const formatDate = (dt) => {
    dt.setHours(0, 0, 0, 0);
    return dt;
  };

  const next = (days) => {
    var dt = new Date();
    dt.setDate(dt.getDate() + days);
    return formatDate(dt);
  };

  return {
    formatDate,
    next
  };
};